/* eslint-disable @typescript-eslint/no-unused-vars */
import getFormatMessage from '../../../../../locales/get-format-message';
import { InvoiceStatus, InvoiceType } from '../../../../../model/api-modules';
import { store } from '../../../../../store';
import { History } from 'history';
import moment from 'moment';
import { formatReqParams } from '../../../../../lib/http/lib';
import { urlWithQueryString } from '../../../../../lib';

export const INVOICE_TYPE_OPTIONS = [
  {
    label: getFormatMessage('invoice_common'),
    value: InvoiceType.Common,
  },
  {
    label: getFormatMessage('invoice_special'),
    value: InvoiceType.Special,
  },
];

export const INVOICE_STATUS_OPTIONS = [
  {
    label: getFormatMessage('invoice_status_applying'),
    value: InvoiceStatus.Applying,
  },
  {
    label: getFormatMessage('invoice_status_opening'),
    value: InvoiceStatus.Opening,
  },
  {
    label: getFormatMessage('invoice_status_success'),
    value: InvoiceStatus.Success,
  },
  {
    label: getFormatMessage('invoice_status_fail'),
    value: InvoiceStatus.Fail,
  },
];

export const getInvoiceTypeText = (invoiceType?: InvoiceType) => {
  return (
    INVOICE_TYPE_OPTIONS.find((item) => item.value === invoiceType)?.label || ''
  );
};

export const goInvoicePage = (
  history: History,
  page = '',
  query: { [key: string]: string | number } = {}
) => {
  const mainPath = `/studio/${
    store.getState().studio.selectStudio?.studioID
  }/fee/invoice-manage`;

  if (!page) {
    history.push(urlWithQueryString(mainPath, query));
    return;
  }
  history.push(urlWithQueryString(`${mainPath}/${page}`, query));
};

export function getFilterList<T>(list: T[], filterValues: Record<string, any>) {
  if (!filterValues || Object.keys(filterValues).length === 0) {
    return list;
  }
  const curList = list as Record<string, any>[];
  const filterList = curList.filter((record) => {
    return Object.keys(filterValues).every((key) => {
      const filterKey = key;
      const filterVal = filterValues[filterKey];
      if (!filterVal) {
        return true;
      }

      const recordVal = record[filterKey];
      if (
        typeof recordVal === 'string' &&
        typeof filterVal === 'string' &&
        recordVal.includes(filterVal)
      ) {
        return true;
      }

      if (
        typeof recordVal === 'number' &&
        typeof filterVal === 'number' &&
        recordVal === filterVal
      ) {
        return true;
      }

      if (
        recordVal &&
        filterVal instanceof Array &&
        moment(filterVal[0]).isValid() &&
        moment(filterVal[1]).isValid()
      ) {
        return (
          moment(recordVal).isSameOrAfter(filterVal[0].startOf('day')) &&
          moment(recordVal).isSameOrBefore(filterVal[1].endOf('day'))
        );
      }

      return false;
    });
  });

  return filterList as T[];
}
